import React from "react";
import { Input as InputBootstrap } from "reactstrap";
import PropTypes from "prop-types";

import styles from "../../assets/scss/component/Input.module.scss";

const Input = (props) => {
  let params = {...props};

  const {
    value,
    onChange,
    onClick,
    onEnterPressed,
    label,
    invalid,
    theme,
    className,
    min,
    max
  } = params;

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && onEnterPressed)
      onEnterPressed(e);
  };

  if (params.onChange)
    delete params.onChange;
  if (params.onEnterPressed)
    delete params.onEnterPressed;
  if (params.label)
    delete params.label;
  if (params.invalid)
    delete params.invalid;

  return (
    <div className={`${styles[theme]} ${styles.input} ${className}`}>
      {label ?
        <label>
          {label}:
        </label>
        : ""}
      <InputBootstrap {...params}
        onChange={onChange}
        onClick={onClick}
        value={value} 
        onKeyDown={handleKeyPress}
        min={min}
        max={max}
      />
      {invalid && typeof(invalid) === "string" ?
        <span className={styles.invalid}>{invalid}</span>
        : ""}
    </div>
  );
};

Input.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onEnterPressed: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  invalid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string,
  theme: PropTypes.oneOf(["bootstrap", "grey"])
};

Input.defaultProps = {
  theme: "bootstrap",
};

export default Input;